import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import styles from "./Discord.module.scss";

export const DiscordIcon = ({ className, color }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="30.075" height="34.361" viewBox="0 0 30.075 34.361">
            <path fill={color} d="M19.952,16.321A1.759,1.759,0,1,1,18.2,14.414,1.831,1.831,0,0,1,19.952,16.321Zm-8.026-1.907a1.914,1.914,0,0,0,0,3.814,1.831,1.831,0,0,0,1.753-1.907A1.82,1.82,0,0,0,11.927,14.414ZM30.075,3.539V34.361c-4.33-3.825-2.945-2.559-7.974-7.233l.911,3.178H3.523A3.531,3.531,0,0,1,0,26.767V3.539A3.531,3.531,0,0,1,3.523,0H26.552A3.531,3.531,0,0,1,30.075,3.539Zm-4.9,16.287A23,23,0,0,0,22.7,9.81a8.5,8.5,0,0,0-4.829-1.8l-.241.275a11.438,11.438,0,0,1,4.279,2.182,14.606,14.606,0,0,0-12.838-.5c-.636.292-1.014.5-1.014.5a11.6,11.6,0,0,1,4.52-2.251l-.172-.206a8.5,8.5,0,0,0-4.829,1.8A23,23,0,0,0,5.1,19.826a6.231,6.231,0,0,0,5.242,2.611s.636-.773,1.151-1.426A5.345,5.345,0,0,1,8.49,18.984c.253.177.67.406.7.43a12.53,12.53,0,0,0,10.724.6A9.835,9.835,0,0,0,21.894,19a5.423,5.423,0,0,1-3.111,2.044c.516.653,1.134,1.392,1.134,1.392A6.282,6.282,0,0,0,25.177,19.826Z" />
        </svg>
    );
};
    
DiscordIcon.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
};

DiscordIcon.defaultProps = {
    color: "#fff"
};